import type { UseQueryResult } from "@tanstack/react-query";

import { Html } from "@/components/html/html";
import type { PublicWarningsLegacyComment } from "@/lib/api/types";
import { useTranslation } from "@/lib/i18n";

import styles from "./risk-picture.module.css";

interface RiskPictureLegacyCommentBodyProps {
  query: UseQueryResult<PublicWarningsLegacyComment>;
}

/** Dialog body for the legacy "toelichting" comment. */
export function RiskPictureLegacyCommentBody({ query }: RiskPictureLegacyCommentBodyProps) {
  const { t } = useTranslation();

  if (query.isPending) return <p>{t("riskPicture.comment.loading")}</p>;
  // A failed background refetch keeps the cached comment; only show the error without data.
  if (query.isError && !query.data) {
    return <p role="alert">{t("riskPicture.comment.loadError")}</p>;
  }
  if (!query.data) return null;
  return (
    <div className={styles.commentBody}>
      <Html content={query.data.description} />
    </div>
  );
}
